import { useEffect } from 'react';

/**
 * Wstrzykuje blok JSON-LD do <head> per strona (z cleanupem przy odmontowaniu).
 * Prerender (Puppeteer) czeka na DOM, wiec wstrzyknięty schemat trafia do statycznego HTML.
 * Przekaz null gdy strona nie ma danego schematu (hook wola sie bezwarunkowo - zasada hooków).
 */
export function useJsonLd(id: string, data: unknown | null) {
  const json = data ? JSON.stringify(data) : null;
  useEffect(() => {
    if (!json) return;
    document.getElementById(id)?.remove();
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.text = json;
    document.head.appendChild(script);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, [id, json]);
}
